import { render, staticRenderFns } from "./ColoradoLagoon.vue?vue&type=template&id=d28bd738&"
import script from "./ColoradoLagoon.vue?vue&type=script&lang=js&"
export * from "./ColoradoLagoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports